'use strict';

$(function () {
    // 初始化页面
    initPage();

    // 绑定事件
    bindEvents();

    // 回车键登录支持
    $('#username, #password').keypress(function (e) {
        if (e.which === 13) {
            // 回车键
            e.preventDefault();
            handleLogin();
        }
    });
});

/**
 * 初始化页面
 */
function initPage() {
    // 隐藏错误信息
    $('.error-msg').removeClass('show');

    // 检查是否有记住的账号
    var savedUsername = localStorage.getItem('savedUsername');
    if (savedUsername) {
        $('#username').val(savedUsername);
    }

    // 检查是否记住协议勾选状态
    var savedAgreement = localStorage.getItem('savedAgreement');
    if (savedAgreement === 'true') {
        $('#agreement').prop('checked', true);
    }

    // 设置表单聚焦
    if (savedUsername) {
        // 如果有记住的账号，则焦点在密码框
        $('#password').focus();
    } else {
        $('#username').focus();
    }

    var errorMsg = getUrlParam('errorMsg');
    if (errorMsg) {
        showErrorMessage(errorMsg);
    }
}

/**
 * 绑定事件
 */
function bindEvents() {
    // 登录按钮点击事件
    $('#login').click(function () {
        handleLogin();
    });

    // 输入框获取焦点时，只有在一定条件下才隐藏错误信息
    $('#username, #password').focus(function () {
        // 只有当错误信息不是"必填字段"类的验证错误时才隐藏
        var $errorMsg = $('.error-msg');
        var currentError = $errorMsg.text();

        // 这些是必填字段验证的错误消息，不自动隐藏
        var requiredFieldErrors = ['请输入小迪账号', '请输入登录密码', '请阅读并同意相关协议'];

        // 如果不是必填字段错误，则隐藏错误信息
        if (requiredFieldErrors.indexOf(currentError) === -1) {
            hideErrorMessage();
        }
    });

    // 输入框输入时隐藏错误信息
    $('#username, #password').on('input', function () {
        hideErrorMessage();
    });

    // 协议复选框事件 - 实时保存勾选状态
    $('#agreement').change(function () {
        var isChecked = $(this).is(':checked');
        // 保存协议勾选状态到localStorage
        localStorage.setItem('savedAgreement', isChecked);

        // 当用户勾选协议时，如果是协议相关的错误则隐藏
        if (isChecked) {
            var $errorMsg = $('.error-msg');
            if ($errorMsg.text() === '请阅读并同意相关协议') {
                hideErrorMessage();
            }
        }
    });
}

/**
 * 处理登录逻辑
 */
function handleLogin() {
    // 获取表单数据
    var username = $('#username').val().trim();
    var password = $('#password').val();
    var isAgreed = $('#agreement').is(':checked');

    // 表单验证
    if (!validateForm(username, password, isAgreed)) {
        return;
    }

    // 显示加载状态
    setLoadingState(true);

    // 准备登录请求数据
    var loginData = {
        login: username,
        password: password
    };

    // 发送登录请求
    $.ajax({
        url: '/login',
        type: 'POST',
        contentType: 'application/json;charset=UTF-8',
        data: JSON.stringify(loginData),
        dataType: 'json',
        success: function success(response) {
            // 处理登录成功
            handleLoginSuccess(response, username);
        },
        error: function error(xhr, status, _error) {
            // 处理登录失败
            handleLoginError(xhr, status, _error);
        },
        complete: function complete() {
            // 恢复按钮状态
            setLoadingState(false);
        }
    });
}

/**
 * 表单验证
 */
function validateForm(username, password, isAgreed) {
    // 清除之前的非必填字段错误信息
    var $errorMsg = $('.error-msg');
    var currentError = $errorMsg.text();

    // 这些是必填字段验证的错误消息，不清除
    var requiredFieldErrors = ['请输入小迪账号', '请输入登录密码', '请阅读并同意相关协议'];

    // 如果不是必填字段错误，则清除
    if (requiredFieldErrors.indexOf(currentError) === -1) {
        hideErrorMessage();
    }

    // 验证用户名
    if (!username) {
        showErrorMessage('请输入小迪账号');
        // 使用setTimeout延迟执行focus，避免立即触发focus事件
        setTimeout(function () {
            $('#username').focus();
        }, 10);
        return false;
    }

    // 验证密码
    if (!password) {
        showErrorMessage('请输入登录密码');
        setTimeout(function () {
            $('#password').focus();
        }, 10);
        return false;
    }

    // 验证协议是否同意
    if (!isAgreed) {
        showErrorMessage('请阅读并同意相关协议');
        // 协议复选框可能不是输入框，但仍然可以设置焦点
        setTimeout(function () {
            $('#agreement').focus();
        }, 10);
        return false;
    }

    // 所有验证通过，清除所有错误信息
    hideErrorMessage();
    return true;
}

/**
 * 处理登录成功
 */
function handleLoginSuccess(response, username) {
    // 根据新的API响应结构处理
    if (response.success === 1) {
        // 登录成功
        showSuccessMessage('登录成功，正在跳转...');

        // 保存用户名到本地存储（记住账号功能）
        localStorage.setItem('savedUsername', username);

        // 保存用户信息到sessionStorage，以便在其他页面使用
        if (response.data) {
            sessionStorage.setItem('userInfo', JSON.stringify(response.data));
        }

        var redirectUrl = getUrlParam('rurl');

        // 确定要跳转的目标URL
        var targetUrl = '/security/goods'; // 默认跳转地址

        if (redirectUrl && isValidRedirectUrl(redirectUrl)) {
            targetUrl = redirectUrl;
        }

        // 执行跳转
        window.location.href = targetUrl;
    } else {
        // 登录失败，显示后端返回的错误信息
        showErrorMessage(response.message || '登录失败，请检查账号密码');

        // 密码错误时清空密码框并设置焦点
        if (response.message && response.message.indexOf('密码') > -1) {
            $('#password').val('');
        }
    }
}

/**
 * 验证重定向URL是否合法（防止开放重定向漏洞）
 * 这里只是一个示例，具体验证逻辑根据需求调整
 */
function isValidRedirectUrl(url) {
    // 检查是否为空
    if (!url) return false;

    // 检查是否为相对路径或同源路径
    // 这里简单判断是否为相对路径（以/开头）且不包含协议（防止javascript:等危险协议）
    var urlPattern = /^(?:\/|\.\/|\.\.\/)/;
    var dangerousPattern = /^(?:javascript:|data:|vbscript:)/i;

    return urlPattern.test(url) && !dangerousPattern.test(url);
}

/**
 * 处理登录错误
 */
function handleLoginError(xhr, status, error) {
    console.error('登录请求失败:', status, error);

    // 根据HTTP状态码显示不同的错误信息
    var errorMessage = '网络错误，请稍后重试';

    if (xhr.status === 401) {
        errorMessage = '账号或密码错误';
    } else if (xhr.status === 403) {
        errorMessage = '账号已被禁用或没有权限';
    } else if (xhr.status === 404) {
        errorMessage = '登录接口不存在';
    } else if (xhr.status === 500) {
        errorMessage = '服务器内部错误，请稍后重试';
    } else if (status === 'timeout') {
        errorMessage = '请求超时，请检查网络连接';
    }

    showErrorMessage(errorMessage);

    // 清空密码框并设置焦点
    $('#password').val('');
}

/**
 * 显示错误信息
 */
function showErrorMessage(message) {
    var $errorMsg = $('.error-msg');
    $errorMsg.text(message);
    $errorMsg.addClass('show');

    // 对于网络或服务器错误，不自动隐藏（让用户看清楚）
    var networkErrors = ['网络错误，请稍后重试', '请求超时，请检查网络连接', '服务器内部错误，请稍后重试', '登录接口不存在'];

    if (networkErrors.indexOf(message) === -1) {
        // 3秒后自动隐藏错误信息
        setTimeout(function () {
            if ($errorMsg.text() === message) {
                hideErrorMessage();
            }
        }, 3000);
    }
}

/**
 * 显示成功信息
 */
function showSuccessMessage(message) {
    var $errorMsg = $('.error-msg');
    $errorMsg.text(message);
    $errorMsg.removeClass('show').addClass('success');

    // 成功信息样式
    $errorMsg.css({
        'color': '#52c41a',
        'background-color': '#f6ffed',
        'border': '1px solid #b7eb8f'
    });
}

/**
 * 隐藏错误信息
 */
function hideErrorMessage() {
    var $errorMsg = $('.error-msg');
    $errorMsg.removeClass('show').removeClass('success');

    // 恢复默认样式
    $errorMsg.css({
        'color': '',
        'background-color': '',
        'border': ''
    });
}

/**
 * 设置加载状态
 */
function setLoadingState(isLoading) {
    var $loginBtn = $('#login');

    if (isLoading) {
        $loginBtn.html('<span class="loading-spinner"></span>登录中...');
        $loginBtn.prop('disabled', true);
        $loginBtn.off('click'); // 移除所有点击事件监听器
    } else {
        $loginBtn.text('登录');
        $loginBtn.prop('disabled', false);

        // 重新绑定点击事件（需要根据你的实际代码调整）
        // 注意：这里假设你的登录按钮点击事件是通过on绑定的
        // 如果事件是直接绑定的，需要重新绑定
        $loginBtn.on('click', function () {
            handleLogin();
        });
    }
}

/**
 * 清除记住的账号（可选功能，可以在需要的地方调用）
 */
function clearSavedAccount() {
    localStorage.removeItem('savedUsername');
    $('#username').val('');
    $('#username').focus();
}

/**
 * 清除协议勾选状态（可选功能，可以在需要的地方调用）
 */
function clearSavedAgreement() {
    localStorage.removeItem('savedAgreement');
    $('#agreement').prop('checked', false);
}